<template>
    <div class="form-field" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <textarea v-model="internalValue" :placeholder="placeholder"></textarea>
                <i :class="langClass" v-if="lang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormFieldTextarea',
        props: ['value','label','name','placeholder','lang','required'],
        data: function () {
            return {
                internalValue: '',
                langClass: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.langClass = this.lang?"flag lang-"+this.lang:"";
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Textarea.vue